<!--
 * @Author: Code-HHX
 * @Date: 2022-03-24 13:51:24
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-03-24 14:04:30
 * @Description:
-->
<template>
  <div class="container">
    <!--头-->
    <div class="header">
      <img
          class="header-menu"
          src="@/assets/icons/icon_menu.png"
          @click="onClickMenu"
      />
      <img
          class="header-bluetooth"
          @click="onClickDisconnectDevice"
          :src="
          isConnected
            ? require('@/assets/icons/icon_bluetooth.png')
            : require('@/assets/icons/icon_bluetooth_disconnected.png')
        "
      />
      <!-- <img class="header-logo" src="@/assets/logo/logo_via.png" /> -->
      <!--<span class="header-title">Wave writer</span>-->

      <img src="@/assets/logo/logo.png" style="width: 105px; height: 41px;"/>
    </div>
    <!--设置内容-->
    <div class="content">
      <div class="model-setting">
        <div class="model-select" ref="modelSelect">
          <div
              class="model-item"
              :class="curveModel === index ? 'model-item-active' : ''"
              v-for="(item, index) in modelList.slice(0, 6)"
              :key="index"
              @click="onClickModelItem(index)"
          >
            {{ item.modeName }}
            <div
                class="model-button"
                :class="curveModel === index ? 'model-button-active' : ''"
            >
              {{ curveModel === index ? "Used" : "Use" }}
            </div>
          </div>
          <div class="model-mask"></div>
        </div>
        <img
            class="setting"
            src="@/assets/icons/icon_setting.png"
            @click="onClickSetting"
        />
      </div>
      <div class="content-main">
        <div class="main-header">
          <!-- <span>{{ modelList[curveModel].text }}</span> -->
          <span>{{ curveTitle }}</span>
          <van-button
              class="main-header-save"
              type="default"
              :disabled="saveDisabled"
              @click="onClickSave"
          >Save
          </van-button>
        </div>
        <div v-if="isSupportSwitchMode" style="font-size:16px;margin:10px 0;">
          <div style="font-size:14px;font-weight: bold">
            Output Mode：
          </div>
          <van-radio-group
              v-model="outputType"
              direction="horizontal"
              @change="onOutputTypeChange"
          >
            <van-radio :name="0x10" checked-color="#8866f5">Voltage</van-radio>
            <van-radio
                v-if="!supportTripleCartridge"
                :name="0x20"
                checked-color="#8866f5"
            >Power
            </van-radio
            >
            <van-radio :name="0x40" checked-color="#8866f5"
            >Temperature
            </van-radio>
          </van-radio-group>
        </div>

        <div v-if="supportDoubleCartridge">
          <div
              style="font-size:14px;font-weight: bold"
              v-if="outputType !== 0x40"
          >
            Cartridge Mode:
          </div>
          <!--双仓模式-->
          <div class="double-cartridge">
            <van-radio-group
                v-if="
                outputType === 0x10 || outputType === 0x20 || outputType === 0
              "
                v-model="doubleCartridgeMode"
                direction="horizontal"
                @change="onDoubleCartridgeModeChange"
            >
              <van-radio :name="0" checked-color="#8866f5">Left</van-radio>
              <van-radio :name="1" checked-color="#8866f5">Right</van-radio>
              <van-radio :name="2" checked-color="#8866f5">Double</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div v-if="supportTripleCartridge">
          <div
              style="font-size:14px;font-weight: bold"
              v-if="outputType !== 0x40"
          >
            Cartridge Mode:
          </div>
          <!--双仓模式-->
          <div class="double-cartridge">
            <van-radio-group
                v-if="
                outputType === 0x10 || outputType === 0x20 || outputType === 0
              "
                v-model="tripleCartridgeMode"
                direction="horizontal"
                @change="onTripleCartridgeModeChange"
            >
              <van-radio :name="0" checked-color="#8866f5">Single</van-radio>
              <van-radio :name="1" checked-color="#8866f5">Double</van-radio>
              <van-radio :name="2" checked-color="#8866f5">Triple</van-radio>
            </van-radio-group>
          </div>
        </div>


        <div
            v-if="outputType === 0 || outputType === 0x10 || outputType === 0x20"
        >
          <!-- 曲线1 -->
          <!-- 曲线2 -->
          <div class="voltage-one">
            <div
                class="voltage-number"
                v-for="(item, index) in modelList[curveModel].diyVoltage.slice(
                0,
                voltageCount
              )"
                :key="index"
            >
              <span v-if="outputType === 0x20">
                {{ Math.abs(item / 100).toFixed(1) }}{{ unitName }}
              </span>
              <span v-else>
                {{ Math.abs(item / 1000).toFixed(1) }}{{ unitName }}
              </span>
            </div>
          </div>

          <div class="voltage-ctrl">
            <div
                class="voltage-number"
                v-for="(item, index) in modelList[curveModel].diyVoltage.slice(
                0,
               voltageCount
              )"
                :key="index"
            >
              <span style="font-size:14px;font-weight: bold; line-height: 30px"
                    @click="stepVoltageOrPower('add',index)">
               +
              </span>
            </div>
          </div>


          <div
              class="voltage-two"
              id="voltageTwo"
              style="width:100%;height:calc(18vh)"
              @touchmove.prevent="onTouchmoveVoltage"
          >
            <van-slider
                v-for="(value, index) in modelList[curveModel].diyVoltage.slice(
                0,
                voltageCount
              )"
                :key="index"
                v-model="modelList[0].diyVoltage[index]"
                vertical
                :min="dragValue.max"
                :max="dragValue.min"
                :step="dragValue.step"
                bar-height="4px"
                active-color="#EEEEEE"
                inactive-color="#6649C4"
                @change="onChangeVoltageCurve(index)"
            >
              <template #button>
                <img
                    class="slider-button"
                    src="@/assets/icons/icon_slider_button.png"
                />
              </template>
            </van-slider>
          </div>

          <div class="voltage-ctrl">
            <div
                class="voltage-number"
                v-for="(item, index) in modelList[curveModel].diyVoltage.slice(
                0,
                voltageCount
              )"
                :key="index"
            >
              <span style="font-size:14px;font-weight: bold;height:20px" @click="stepVoltageOrPower('sub',index)">
               -
              </span>
            </div>
          </div>

          <div class="voltage-three" v-if="false">
            <div class="voltage-number" v-for="index of 6" :key="index">
              {{ ((outputDuration / 1000) * index).toFixed(2) }}s
            </div>
          </div>
          <div class="description" v-if="false">
            {{ modelList[0].heatingRemarks }}
          </div>

          <div style="margin-top:24px">
            <div class="device-level" v-if="supportLevel">
              Curve：
              <van-dropdown-menu>
                <van-dropdown-item ref="item">
                  <template #title>
                    <div class="drop-item-level">
                      {{ currentDeviceLevelItem.text }}
                    </div>
                  </template>
                  <template>
                    <div
                        class="drop-item-level__wrap"
                        v-for="(item, index) in deviceLevelList"
                        :key="index"
                        @click="onLevelDropdown(item)"
                    >
                      <div
                          style="display: flex;align-items: center;justify-content: center"
                          class="drop-item-level__content"
                      >
                        <span>{{ item.text }}</span>
                      </div>
                    </div>
                  </template>
                </van-dropdown-item>
              </van-dropdown-menu>
            </div>

            <div class="control">
              <div
                  v-if="false"
                  class="control-left"
                  :style="{
                  color: modelList[0].isSupportPreheat ? '#6649C4' : '#ddd'
                }"
              >
                <div class="title">
                  Preheat
                  <van-switch
                      @change="onClickModelItem(0)"
                      class="preheat-switch"
                      v-model="modelList[0].isSupportPreheat"
                      active-color="#66DCA5"
                      inactive-color="#D6CDF2"
                      size="20"
                  />
                </div>
                <div class="subtitle">
                  Times：<span
                    :style="{
                      color: modelList[0].isSupportPreheat ? '#6649C4' : '#ddd'
                    }"
                >{{ (modelList[0].preheatTime / 1000).toFixed(1) }}s</span
                >
                </div>
                <!--预热时间-->
                <div class="times-item">
                  <van-slider
                      v-model="modelList[0].preheatTime"
                      min="1000"
                      max="20000"
                      @change="onClickModelItem(0)"
                      :step="500"
                      bar-height="4px"
                      active-color="#6649C4"
                      inactive-color="#FFFFFF"
                      :disabled="!modelList[0].isSupportPreheat"
                  >
                    <template #button>
                      <img
                          class="slider-button"
                          :src="
                          modelList[0].isSupportPreheat
                            ? require('@/assets/icons/icon_slider_button_vertical.png')
                            : require('@/assets/icons/icon_slider_button_vertical_disabled.png')
                        "
                      />
                    </template>
                  </van-slider>
                  <div class="times-item-msg">
                    <div class="times-left">1&nbsp;s</div>
                    <div class="times-right">20&nbsp;s</div>
                  </div>
                </div>
                <div class="subtitle">
                  Voltage：<span
                    :style="{
                      color: modelList[0].isSupportPreheat ? '#6649C4' : '#ddd'
                    }"
                >{{
                    (modelList[0].preheatVoltage / 1000).toFixed(1)
                  }}v</span
                >
                </div>

                <!--预热电压-->
                <div class="voltage-item">
                  <van-slider
                      v-model="modelList[0].preheatVoltage"
                      min="100"
                      max="4200"
                      :step="100"
                      bar-height="4px"
                      active-color="#6649C4"
                      inactive-color="#FFFFFF"
                      :disabled="!modelList[0].isSupportPreheat"
                  >
                    <template #button>
                      <img
                          class="slider-button"
                          :src="
                          modelList[0].isSupportPreheat
                            ? require('@/assets/icons/icon_slider_button_vertical.png')
                            : require('@/assets/icons/icon_slider_button_vertical_disabled.png')
                        "
                      />
                    </template>
                  </van-slider>
                  <div class="voltage-item-msg">
                    <div class="voltage-left">0.1&nbsp;v</div>
                    <div class="voltage-right">4.2&nbsp;v</div>
                  </div>
                </div>
              </div>
              <div
                  class="control-right"
                  v-if="
                  supportCustomOutputDuration &&
                    [0, 0x10, 0x20].includes(outputType)
                "
                  :style="{
                  // visibility: supportOutputDuration ? 'visible' : 'hidden',
                  color: enableCtrlFunc ? '#6649C4' : '#ddd'
                }"
              >
                <div v-if="false" class="title">
                  NFC Settings
                </div>
                <!--            <van-switch
                  class="nfc-switch"
                  @change="onClickModelItem(0)"
                  v-model="modelList[0].isSupportNfc"
                  active-color="#66DCA5"
                  inactive-color="#D6CDF2"
                  size="20"
                />-->
                <!--            <van-switch-->
                <!--              class="nfc-switch"-->
                <!--              @change="onClickCtrlFunc"-->
                <!--              v-model="enableCtrlFunc"-->
                <!--              active-color="#66DCA5"-->
                <!--              inactive-color="#D6CDF2"-->
                <!--              size="20"-->
                <!--            />-->
                <div
                    class="title"
                    :style="{
                    color: disabledCtrlFuncUI ? '#ddd' : '#6649C4'
                  }"
                >
                  Output Duration
                </div>
                <input
                    :disabled="disabledCtrlFuncUI"
                    type="number"
                    style="margin-top:10px"
                    :min="0"
                    :max="2500"
                    @blur="onOutputDurationChange"
                    v-model="outputDurationValue"
                />
                <div
                    class="title"
                    v-if="false"
                    :style="{
                    color: disabledCtrlFuncUI ? '#ddd' : '#6649C4',
                    marginTop: '10px'
                  }"
                >
                  Temperature Ctrl
                </div>
                <input
                    v-if="false"
                    :disabled="disabledCtrlFuncUI"
                    type="number"
                    style="margin-top:10px"
                    :min="0"
                    :max="255"
                    @blur="onTemperatureOutputValueChange"
                    v-model="tempCtrlValue"
                />
              </div>

              <div
                  class="output-setting"
                  v-else-if="
                  supportCustomXYZModeOutputDuration &&
                    [0, 0x10, 0x20].includes(outputType)
                "
              >
                <div class="title">
                  Output Settings
                </div>

                <van-radio-group
                    v-model="outputSetting"
                    direction="horizontal"
                    @change="onOutputSettingChange"
                >
                  <van-radio name="1" checked-color="#6649C4">X Mode</van-radio>
                  <van-radio name="2" checked-color="#6649C4">Y Mode</van-radio>
                  <van-radio name="3" checked-color="#6649C4">Z Mode</van-radio>
                </van-radio-group>
              </div>
            </div>
          </div>
        </div>


        <div v-if="supportTripleCartridge && outputType === 0x40">
          <TripleTemperatureSetting v-model="modelList[0]"/>
        </div>
        <div v-else>
          <TemperatureSetting
              style="margin-top:12px;"
              v-if="isSupportSwitchMode && outputType === 0x40"
              v-model="modelList[0]"
          />
          <TemperatureSetting2
              style="margin-top:12px;padding-bottom:60px"
              :double-cartridge-mode="supportDoubleCartridge"
              v-if="
              outputType === 0x40 &&
                supportDoubleCartridge &&
                isSupportSwitchMode
            "
              v-model="modelList[0]"
          />
        </div>
      </div>
    </div>

    <!--底部-->
    <div class="footer">
      <div class="footer-item">
        <img
            class="footer-setting"
            src="@/assets/icons/icon_footer_setting.png"
            @click="onClickSettingsView"
        />
        <img
            class="footer-upload"
            src="@/assets/icons/icon_upload.png"
            @click="onClickUpload"
        />
        <img
            class="footer-history"
            src="@/assets/icons/icon_history.png"
            @click="onClickHistory"
        />
      </div>
    </div>
    <!-- 左侧菜单Popup -->
    <van-popup
        class="menu-popup"
        v-model="showMenuPopup"
        position="left"
        :style="{ height: '100%', width: '88%' }"
        round
    >
      <div class="menu-header">
        <van-icon
            class="menu-return"
            name="arrow-left"
            size="25"
            color="#ffffff"
            @click="onClickMenuReturn()"
        />
        <img src="@/assets/logo/logo_wave_writer.png" alt=""/>
      </div>
      <div class="menu-content">
        <!-- <div class="menu-item">
          <img src="@/assets/icons/icon_user.png" alt="" />My Profiles
        </div>
        <div class="menu-item">
          <img src="@/assets/icons/icon_pwd.png" alt="" />Change Password
        </div> -->
        <div class="menu-footer">
          <span class="menu-footer-left">V 1.0.11</span>
          <span class="menu-footer-right" @click="onClickSignOut"
          ><img src="@/assets/icons/icon_sign_out.png" alt=""/>Sign out</span
          >
        </div>
      </div>
    </van-popup>
    <!-- 连接蓝牙弹窗Popup -->
    <van-popup
        class="bluetooth-popup"
        v-model="showBluetoothPopup"
        round
        :style="{ width: '88%' }"
    >
      <div class="bluetooth-header">Connect Device</div>
      <div class="bluetooth-content">
        <van-loading color="#6649C4" size="40" text-size="16px"
        >{{ bluetoothPopupMsg }}
        </van-loading>
        <div class="bluetooth-list">
          <div
              class="bluetooth-item"
              v-for="(item, index) in deviceList"
              :key="index"
          >
            <img src="@/assets/icons/icon_bluetooth_device.png"/>
            {{ item.name }}
            <van-button
                class="bluetooth-connect-button"
                type="default"
                @click="onClickConnectDevice(item)"
            >Connect
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 断开蓝牙弹窗 Disconnect -->
    <van-popup
        class="save-popup"
        v-model="showDisconnectPopup"
        round
        :style="{ width: '88%' }"
        :close-on-click-overlay="false"
    >
      <div class="save-header">Tips</div>
      <div class="save-content">
        <div class="save-content-msg">
          Are you sure to disconnect?
        </div>
        <div class="save-footer">
          <button
              class="save-footer-cancel"
              @click="onClickDisconnectCancel"
              v-waves
          >
            Cancel
          </button>
          <button
              class="save-footer-sure"
              @click="onClickDisconnectSure"
              v-waves
          >
            Sure
          </button>
        </div>
      </div>
    </van-popup>
    <!-- 保存弹窗 Save -->
    <van-popup
        class="save-popup"
        v-model="showSavePopup"
        round
        :style="{ width: '88%' }"
        :close-on-click-overlay="false"
    >
      <div class="save-header">Tips</div>
      <div class="save-content">
        <div class="save-content-msg">
          Are you sure save the settings?
        </div>
        <div class="save-footer">
          <button class="save-footer-cancel" @click="onClickSaveCancel" v-waves>
            Cancel
          </button>
          <button class="save-footer-sure" @click="onClickSaveSure" v-waves>
            Sure
          </button>
        </div>
      </div>
    </van-popup>
    <!-- 退出登录弹窗 Logout -->
    <van-popup
        class="save-popup"
        v-model="showLogoutPopup"
        round
        :style="{ width: '88%' }"
        :close-on-click-overlay="false"
    >
      <div class="save-header">Tips</div>
      <div class="save-content">
        <div class="save-content-msg">
          Are you sure you want to log out?
        </div>
        <div class="save-footer">
          <button
              class="save-footer-cancel"
              @click="onClickLogout(false)"
              v-waves
          >
            Cancel
          </button>
          <button class="save-footer-sure" @click="onClickLogout(true)" v-waves>
            Sure
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { WriterSetting } from "@/bluetooth/BluetoothData";
import { mapGetters, mapState } from "vuex";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import api from "@/api";
import preventBack from "vue-prevent-browser-back";
import {
  excludeDeviceDoubleCartridge,
  getDeviceSupportLevelList,
  isBtDeviceSupportLevel,
  isBtDeviceSupportOutputDuration,
  isSupportDoubleCartridge,
  isSupportSwitchMode,
  isSupportSwitchModeSpecial,
  isSupportTripleCartridge
} from "@/util/utils";
import TemperatureSetting from "@/components/TemperatureSetting.vue";
import TemperatureSetting2 from "@/components/TemperatureSetting2.vue";
import { BLUETOOTH_MODULE_NAME } from "@/bluetooth/store/StoreType";
import TripleTemperatureSetting from "@/components/TripleTemperatureSetting.vue";
import { excludeSwitchMode, voltageNumber } from "@/util/utils";

export default {
  name      : "Home",
  components: {
    TripleTemperatureSetting,
    TemperatureSetting,
    TemperatureSetting2
  },
  mixins    : [preventBack], //注入
  data() {
    return {
      outputSetting      : "1", // 1 2 3对应x y z
      curveModel         : 0,
      modelList          : [{ diyVoltage: [] }],
      myChart            : {},
      showMenuPopup      : false,
      showBluetoothPopup : false,
      bluetoothPopupMsg  : "Searching...",
      showDisconnectPopup: false,
      showSavePopup      : false,
      showLogoutPopup    : false,
      outputDuration     : 250,
      currentDeviceLevel : 0,
      enableCtrlFunc     : true,
      disabledCtrlFuncUI : false,

      outputDurationValue: parseInt(
          localStorage.getItem("outputDurationValue") || "250"
      ),
      tempCtrlValue      : parseInt(localStorage.getItem("tempCtrlValue") || "100"),

      currentDeviceLevelItem  : { text: "1", value: 1 },
      deviceLevelList         : [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 }
      ],
      doubleCartridgeMode     : 0,
      doubleCartridgeModeValue: 0,
      tripleCartridgeMode     : 0,
      tripleCartridgeModeValue: 0,
      outputType              : 0x0,
      lastOutputType          : 0x0,
      curveTitle              : "Voltage Curve",
      unitName                : "v",
      dragValue               : {
        max : -4200,
        min : -100,
        step: 100
      },
      voltageLastData         : null,
      powerLastData           : null,
      temperatureLastData     : null
    };
  },
  async created() {
  },
  async activated() {
    const { setting, refresh } = this.$route.params;
    if (setting) {
      this.modelList[0].id       = 0;
      this.modelList[0].modeName = "DIY";
      const origin               = setting.diyVoltage;

      if (this.isSupportSwitchMode) {
        if (this.isSupportSwitchModeSpecial) {
          this.outputType = setting.touchSensitivity;
        } else {
          this.outputType = this.deviceId.type;
        }

        if (this.lastOutputType !== this.outputType) {
          switch (this.lastOutputType) {
            case 0:
            case 0x10:
              this.voltageLastData            = Object.assign({}, this.modelList[0]);
              this.voltageLastData.diyVoltage = [].concat(
                  this.modelList[0].diyVoltage
              );
              console.log(this.modelList[0].diyVoltage);
              break;
            case 0x20:
              this.powerLastData            = Object.assign({}, this.modelList[0]);
              this.powerLastData.diyVoltage = [].concat(
                  this.modelList[0].diyVoltage
              );
              console.log(this.modelList[0].diyVoltage);
              break;
            case 0x40:
              this.temperatureLastData            = Object.assign({}, this.modelList[0]);
              this.temperatureLastData.diyVoltage = [].concat(
                  this.modelList[0].diyVoltage
              );
              break;
          }
        }
        this.lastOutputType = this.outputType;
      }

      Object.assign(this.modelList[0], setting);
      this.modelList[0].diyVoltage = [].concat(origin);
      if (this.outputType !== 0x40 && this.supportOutputDuration) {
        this.outputDurationValue = setting.micSensitivity * 10
      }

      this.curveModel = 0;
      if (this.supportLevel) {
        this.currentDeviceLevel = setting.touchSensitivity;

        this.currentDeviceLevelItem = this.deviceLevelList[
            setting.touchSensitivity
            ];
      }
      if (this.supportDoubleCartridge) {
        this.doubleCartridgeMode = setting.touchSensitivity & 0x0f;
      }
      if (this.supportTripleCartridge) {
        this.tripleCartridgeMode = setting.touchSensitivity & 0x0f;
      }

      this.$refs.modelSelect.scrollTo(0, 0);
    }
    if (refresh) {
      let writerCurves = await api.writer.selectCustomFirmwareSettings();
      await this.$store.dispatch("loadWriterCurves", writerCurves);
      const diySetting = this.getDiySetting();
      this.modelList   = [diySetting].concat(this.getCurveModes());
      this.curveModel  = 0;
    }
  },
  async mounted() {
    const diySetting = this.getDiySetting();
    const curveModes = this.getCurveModes();
    if (curveModes === null) {
      //登录后，没数据的话，从网络获取
      let writerCurves = await api.writer.selectCustomFirmwareSettings();
      await this.$store.dispatch("loadWriterCurves", writerCurves);
      this.modelList = [diySetting].concat(this.getCurveModes());
    } else {
      this.modelList = [diySetting].concat(curveModes);
    }
    if (!this.supportCustomOutputDuration) {
      this.outputDurationValue = 250;
    }
  },

  computed: {
    ...mapState({
      isConnected  : state => state.bluetooth.isConnected,
      deviceList   : state => state.bluetooth.deviceList,
      deviceVersion: state => state.bluetooth.deviceVersion,
      macAddress   : state => state.bluetooth.macAddress,
      cartridgeFlag: state => state.bluetooth.cartridgeFlag,
      deviceId     : state => state.bluetooth.deviceId,
      outputMode   : state => state.bluetooth.outputMode,
      r1           : state => state.bluetooth.r1,
      doubleR1     : state => state.bluetooth.doubleR1,
      centerR1     : state => state.bluetooth.doubleR1,
      rightR1      : state => state.bluetooth.tripleR1
    }),
    ...mapState("bluetooth", ["writerSetting"]),
    ...mapState(["userInfo"]),
    voltageCount() {
      return voltageNumber(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      )
    },
    isSupportSwitchMode() {
      return isSupportSwitchMode(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      ) && !excludeSwitchMode(
          this.deviceId.productManufacture,
          this.deviceId.productNumber);
      ;
    },
    isSupportSwitchModeSpecial() {
      return isSupportSwitchModeSpecial(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      ) && !excludeSwitchMode(
          this.deviceId.productManufacture,
          this.deviceId.productNumber);
      ;
    },
    supportCustomOutputDuration() {
      const userInfo = this.userInfo;
      return (
          (userInfo.roleId === 30 || userInfo.roleId === 31) &&
          this.supportOutputDuration
      );
    },
    supportCustomXYZModeOutputDuration() {
      const userInfo = this.userInfo;
      return !(userInfo.roleId === 30 || userInfo.roleId === 31);
    },
    supportLevel() {
      return isBtDeviceSupportLevel(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    supportDoubleCartridge() {
      return isSupportDoubleCartridge(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      ) && !excludeDeviceDoubleCartridge(
          this.deviceId.productManufacture,
          this.deviceId.productNumber);
    },
    saveDisabled() {
      if (this.curveModel === 0) {
        return false;
      } else {
        return true;
      }
    },
    supportOutputDuration() {
      return isBtDeviceSupportOutputDuration(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    supportTripleCartridge() {
      return isSupportTripleCartridge(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    }
  },
  watch   : {
    writerSetting(val) {
      if (!val) {
        return;
      }
      if (this.isSupportSwitchModeSpecial) {
        //特殊的 5 - 2 设备
        const outputType = val.touchSensitivity;
        this.outputType  = outputType;
        switch (outputType) {
          case 0:
          case 0x10:
            this.curveTitle = "Voltage Curve";
            this.unitName   = "v";
            this.dragValue  = {
              max : -4200,
              min : -100,
              step: 100
            };
            break;
          case 0x20:
            this.curveTitle = "Power Curve";
            this.unitName   = "w";
            this.dragValue  = {
              max : -1500,
              min : -10,
              step: 100
            };
            break;
          case 0x40:
            break;
        }
        return;
      }

      if (this.isSupportSwitchMode) {
        //是否支持切换模式的设备
        const outputType = this.deviceId.type;
        console.log(`outputType = ${outputType}`);
        this.outputType = outputType;
        switch (outputType) {
          case 0:
          case 0x10:
            this.curveTitle = "Voltage Curve";
            this.unitName   = "v";
            this.dragValue  = {
              max : -4200,
              min : -100,
              step: 100
            };
            break;
          case 0x20:
            this.curveTitle = "Power Curve";
            this.unitName   = "w";
            this.dragValue  = {
              max : -1500,
              min : -10,
              step: 100
            };
            break;
          case 0x40:
            break;
          default:
            this.curveTitle = "Voltage Curve";
            this.unitName   = "v";
            this.dragValue  = {
              max : -4200,
              min : -100,
              step: 100
            };
            break;
        }
        // this.onOutputTypeChange(outputType)
      } else {
        this.outputType = 0;
        this.$store.commit(`${BLUETOOTH_MODULE_NAME}setHubOutputMode`, 0);
      }

      if (this.supportDoubleCartridge) {
        //是否支持双仓
        // const value = val.touchSensitivity & 0x0f; //双仓就获取touchSensitivity的低4位作为标志
        // if (value === 0 || value === 1) {
        //   // 0是左仓，1是右仓
        //   this.doubleCartridgeMode = value;
        //   this.doubleCartridgeModeValue = value;
        // } else if (value === 2) {
        //   this.doubleCartridgeMode = 10; //这里的10是用作UI绑定使用
        //   this.doubleCartridgeModeValue = val.touchSensitivity >> 4; //这个就是真实的双仓数据
        // }
        // this.doubleCartridgeMode = val.touchSensitivity ;
      }
    },
    deviceList(value) {
      //console.log(value);
    },
    isConnected(value) {
      if (value) this.showBluetoothPopup = false;
    },
    showBluetoothPopup(value) {
      if (!value) {
        bluetoothRepository.cancelSearch();
        this.bluetoothPopupMsg = "Searching...";
      }
    },
    supportLevel(value) {
      console.log(`value = ${value}`);
      // if (!value) {
      // }
    },
    deviceId(value) {
      if (
          !isBtDeviceSupportOutputDuration(
              value.productManufacture,
              value.productNumber
          )
      ) {
        this.outputDurationValue = 1000;
        this.outputDuration      = 1000;
      }

      if (this.supportLevel) {
        this.deviceLevelList = getDeviceSupportLevelList(
            value.productManufacture,
            value.productNumber
        );
        // this.onLevelDropdown(this.deviceLevelList[0]);
      }
    }
  },
  methods : {
    ...mapGetters(["getCurveModes", "getDiySetting"]),
    // onMaterialChange(e) {
    //   this.temperatureRCtrl.materialType = e;
    //   this.$store.commit(`${BLUETOOTH_MODULE_NAME}setMaterialType`, e);
    // },
    stepVoltageOrPower(op, index) {
      this.onChangeVoltageCurve()
      const modelList = this.modelList[0]
      if (op === 'add') {
        if (modelList.diyVoltage[index] <= this.dragValue.max) {
          this.$set(modelList.diyVoltage, index, this.dragValue.max)
          return
        }
        const origin = modelList.diyVoltage[index]
        this.$set(modelList.diyVoltage, index, origin - 100)
      } else {
        if (modelList.diyVoltage[index] >= this.dragValue.min) {
          this.$set(modelList.diyVoltage, index, this.dragValue.min)
          return
        }
        const origin = modelList.diyVoltage[index]
        this.$set(modelList.diyVoltage, index, origin + 100)
      }
    },
    onOutputTypeChange(mode) {
      // console.log(mode);
      console.log(this.lastOutputType);
      switch (mode) {
        case 0:
        case 0x10:
          if (this.lastOutputType === 0x20) {
            this.powerLastData            = Object.assign({}, this.modelList[0]);
            this.powerLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          }
          if (this.lastOutputType === 0x40) {
            this.temperatureLastData            = Object.assign({}, this.modelList[0]);
            this.temperatureLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          }
          if (this.voltageLastData != null) {
            this.voltageLastData.diyVoltage.forEach((item, index) => {
              this.modelList[0].diyVoltage[index] = item;
            });
          }
          this.curveTitle = "Voltage Curve";
          this.unitName   = "v";
          this.dragValue  = {
            max : -4200,
            min : -100,
            step: 100
          };

          break;
        case 0x20:
          if (this.lastOutputType === 0 || this.lastOutputType === 0x10) {
            this.voltageLastData            = Object.assign({}, this.modelList[0]);
            this.voltageLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          }
          if (this.lastOutputType === 0x40) {
            this.temperatureLastData            = Object.assign({}, this.modelList[0]);
            this.temperatureLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          }
          if (this.powerLastData != null) {
            this.powerLastData.diyVoltage.forEach((item, index) => {
              this.modelList[0].diyVoltage[index] = item;
            });
          } else {
            this.modelList[0].diyVoltage.forEach((item, index) => {
              this.modelList[0].diyVoltage[index] = -100;
            });
          }
          this.curveTitle = "Power Curve";
          this.unitName   = "w";
          this.dragValue  = {
            max : -1500,
            min : -10,
            step: 100
          };
          break;
        case 0x40:
          if (this.supportDoubleCartridge) {
            this.doubleCartridgeMode = 2;
          }
          if (this.lastOutputType === 0 || this.lastOutputType === 0x10) {
            this.voltageLastData            = Object.assign({}, this.modelList[0]);
            this.voltageLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          } else if (this.lastOutputType === 0x20) {
            this.powerLastData            = Object.assign({}, this.modelList[0]);
            this.powerLastData.diyVoltage = [].concat(
                this.modelList[0].diyVoltage
            );
          }
          if (this.temperatureLastData != null) {
            this.powerLastData.diyVoltage.forEach((item, index) => {
              this.modelList[0].diyVoltage[index] = item;
            });
          } else {
            this.modelList[0].diyVoltage.forEach((item, index) => {
              this.modelList[0].diyVoltage[index] = -100;
            });
          }
          this.curveTitle = "Temperature Settings";
          this.unitName   = "";
      }
      this.lastOutputType = mode;
    },
    onTemperateChange(type) {
      switch (type) {
        case "t":
          if (this.temperatureRCtrl.temperature > 1.2) {
            this.temperatureRCtrl.temperature = 1.2;
          }
          break;
        case "p1":
          if (this.temperatureRCtrl.pushPower > 10) {
            this.temperatureRCtrl.pushPower = 10;
          }
          break;
        case "p2":
          if (this.temperatureRCtrl.proportion > 16) {
            this.temperatureRCtrl.temperature = 15;
          }
          break;
        case "i":
          if (this.temperatureRCtrl.integral > 16) {
            this.temperatureRCtrl.integral = 15;
          }
          break;
      }
    },
    onDoubleCartridgeModeChange(e) {
      this.doubleCartridgeMode      = e;
      this.doubleCartridgeModeValue = e;
      // if (e === 0 || e === 1) {
      //   this.doubleCartridgeModeValue = e;
      // } else {
      //   this.doubleCartridgeModeValue = 3;
      // }
    },
    onTripleCartridgeModeChange(e) {
      this.tripleCartridgeMode      = e;
      this.tripleCartridgeModeValue = e;
      // if (e === 0 || e === 1) {
      //   this.doubleCartridgeModeValue = e;
      // } else {
      //   this.doubleCartridgeModeValue = 3;
      // }
    },
    onDoubleCartridgeMode2Change(e) {
      this.doubleCartridgeModeValue = e;
    },
    onOutputSettingChange(e) {
      switch (e) {
        case "1":
          this.outputDurationValue = 250;
          break;
        case "2":
          this.outputDurationValue = 500;
          break;
        case "3":
          this.outputDurationValue = 1000;
          break;
        default:
          this.outputDurationValue = 250;
          break;
      }
    },
    onLevelDropdown(value) {
      this.currentDeviceLevelItem = value;
      this.currentDeviceLevel     = value.value - 1;
      console.log(`level = ${this.currentDeviceLevel}`);
      if (this.$refs.item) {
        this.$refs.item.toggle();
      }
    },
    onOutputDurationChange(e) {
      console.log(`on blur ${e.target.value}`);
      const value = e.target.value;
      this.$nextTick(() => {
        if (value < 100) {
          this.outputDurationValue = 100;
        } else if (value > 2500) {
          this.outputDurationValue = 2500;
        } else {
          this.outputDurationValue = value;
        }
      });
    },
    onTemperatureOutputValueChange(e) {
      console.log(`on blur ${e.target.value}`);
      const value = e.target.value;
      this.$nextTick(() => {
        if (value < 0) {
          this.tempCtrlValue = 0;
        } else if (value > 255) {
          this.tempCtrlValue = 255;
        } else {
          this.tempCtrlValue = value;
        }
      });
    },
    onClickMenu() {
      this.showMenuPopup = true;
    },

    onClickMenuReturn() {
      this.showMenuPopup = false;
    },

    onClickSignOut() {
      this.showLogoutPopup = true;
    },

    onClickModelItem(index) {
      this.curveModel = index;
      Object.assign(this.modelList[0], this.modelList[index]);
      this.modelList[0].id       = 0;
      this.modelList[0].modeName = "DIY";
      if (index == 0) this.modelList[0].heatingRemarks = "";
      const origin                 = this.modelList[index].diyVoltage;
      this.modelList[0].diyVoltage = [].concat(origin);
      if (this.modelList[0].position > 0) {
        this.currentDeviceLevel     = this.modelList[0].position - 1
        this.currentDeviceLevelItem = this.deviceLevelList[this.currentDeviceLevel]
      }

      const outputDuration = this.modelList[0].outputInterval
      if (outputDuration > 0) {
        this.outputSetting       = outputDuration
        this.outputDurationValue = outputDuration
      }
    },

    onClickCtrlFunc(e) {
      this.disabledCtrlFuncUI = !e;
    },

    onClickSetting() {
      let selectVoltage = [];
      this.modelList.forEach(element => {
        if (element.modeName != "DIY") {
          const model    = {};
          model.id       = element.id;
          model.modeName = element.modeName;
          model.checked  = true;
          selectVoltage.push(model);
        }
      });
      this.$router.replace({
        name  : "Settings",
        params: {
          selectVoltage
        }
      });
    },

    onTouchmoveVoltage(e) {
    },

    onChangeVoltageCurve(index) {
      if (this.curveModel !== 0) {
        this.curveModel = 0;
        this.$refs.modelSelect.scrollTo(0, 0);
      }
    },

    onClickSave() {
      this.showSavePopup = true;
    },
    onClickDisconnectDevice() {
      if (this.isConnected) {
        this.showDisconnectPopup = true;
      } else {
        bluetoothRepository.startPair();
        //如果浏览器有receiveScanDevice发送蓝牙设备列表则走web方式，没有走原生
        if (Object.prototype.hasOwnProperty.call(window, "receiveScanDevice")) {
          this.showBluetoothPopup = true;
        }
      }
    },
    onClickConnectDevice(device) {
      if (device) {
        this.bluetoothPopupMsg = "Connecting...";
        bluetoothRepository.connectDevice(device, false);
      }
    },
    onClickSettingsView() {
      if (!this.isConnected) {
        this.$toast({
          type    : "fail",
          duration: "1000",
          position: "center",
          message : "Not connected"
        });
        return;
      }

      this.$router.push("SettingsView");
    },
    async onClickUpload() {
      if (!this.isConnected) {
        this.$toast({
          type    : "fail",
          duration: "1000",
          position: "center",
          message : "Not connected"
        });
        return;
      }

      const writerSetting = new WriterSetting();
      if ([0x0, 0x10, 0x20].includes(this.outputType)) {
        Object.assign(writerSetting, this.modelList[this.curveModel]);
        let lastVoltage          = 2100;
        writerSetting.diyVoltage = writerSetting.diyVoltage.map(
            (item, index) => {
              if (index === 5) {
                lastVoltage = item;
              } else if (this.voltageCount === 6 && index > 5) {
                return Math.abs(lastVoltage);
              }
              return Math.abs(item);
            }
        );
        const length             = writerSetting.diyVoltage.length;
        if (length <= 6) {
          const lastVoltage = writerSetting.diyVoltage[length - 1];
          writerSetting.diyVoltage.push(lastVoltage);
          writerSetting.diyVoltage.push(lastVoltage);
        }
        try {
          console.log(this.currentDeviceLevel);
          if (
              this.supportLevel &&
              this.currentDeviceLevel > 0 &&
              this.currentDeviceLevel <= 70
          ) {
            writerSetting.diyVoltage[0] =
                ((writerSetting.diyVoltage[0] / 100) |
                    (this.currentDeviceLevel << 6)) *
                100;
          }

          writerSetting.micSensitivity = this.outputDurationValue;
          if (this.isSupportSwitchMode) {
            writerSetting.touchSensitivity = this.outputType;
            this.$store.commit(
                `${BLUETOOTH_MODULE_NAME}setHubOutputMode`,
                this.outputType
            );
          } else {
            this.$store.commit(`${BLUETOOTH_MODULE_NAME}setHubOutputMode`, 0);
            // if (this.enableCtrlFunc) {
            writerSetting.touchSensitivity = this.tempCtrlValue;
            localStorage.setItem("tempCtrlValue", this.tempCtrlValue);
          }
          if (this.supportDoubleCartridge) {
            console.log(
                `this.doubleCartridgeModeValue = ${this.doubleCartridgeModeValue}`
            );
            writerSetting.diyVoltage[0] =
                ((writerSetting.diyVoltage[0] / 100) |
                    (this.doubleCartridgeMode << 6)) *
                100;
          }
          if (this.supportTripleCartridge) {
            console.log(
                `this.doubleCartridgeModeValue = ${this.supportTripleCartridge}`
            );
            writerSetting.diyVoltage[0] =
                ((writerSetting.diyVoltage[0] / 100) |
                    (this.tripleCartridgeMode << 6)) *
                100;
          }
          writerSetting.micSensitivity = this.outputDurationValue;
          localStorage.setItem("outputDurationValue", this.outputDuration);

          await bluetoothRepository.writeToWriterWithAllFunc(writerSetting);
          this.outputDuration = parseInt(`${this.outputDurationValue}`);

          this.$toast({
            type    : "success",
            duration: "1000",
            position: "center",
            message : "Upload success"
          });
        } catch (e) {
          this.$toast({
            type    : "fail",
            duration: "1000",
            position: "center",
            message : "Send fail!"
          });
          return;
        }
      } else if (this.outputType === 0x40) {
        this.$store.commit(
            `${BLUETOOTH_MODULE_NAME}setHubOutputMode`,
            this.outputType
        );
        if (this.supportDoubleCartridge) {
          console.log(`R2 = ${this.calcR2() * 1000}`);
          console.log(`Double R2 = ${this.calcR2Double() * 1000}`);
          const diffR1 = parseInt(Math.abs(Math.round(this.calcR2() * 1000)));
          const diffR2 = parseInt(
              Math.abs(Math.round(this.calcR2Double() * 1000))
          );

          console.log(`ttt = ${this.modelList[0].temperature}`);
          console.log(`ttt = ${this.modelList[0].temperature2}`);
          writerSetting.diyVoltage = [
            (diffR1 & 0x00ff) * 100,
            (diffR1 >> 8) * 100,
            this.modelList[0].pushPower * 100,
            (diffR2 & 0x00ff) * 100,
            (diffR2 >> 8) * 100,
            this.modelList[0].pushPower2 * 100,
            0,
            0
          ];
        } else if (this.supportTripleCartridge) {
          console.log(`R2 = ${this.calcR2() * 1000}`);
          console.log(`Double R2 = ${this.calcR2Double() * 1000}`);
          const diffR1 = parseInt(Math.abs(Math.round(this.calcR2() * 1000)));
          const diffR2 = parseInt(
              Math.abs(Math.round(this.calcR2Double() * 1000))
          );
          const diffR3 = parseInt(
              Math.abs(Math.round(this.calcR3Double() * 1000))
          );

          console.log(`ttt = ${this.modelList[0].temperature}`);
          console.log(`ttt = ${this.modelList[0].temperature2}`);
          writerSetting.micSensitivity = this.modelList[0].pushPower;
          writerSetting.diyVoltage     = [
            (diffR1 & 0x00ff) * 100,
            (diffR1 >> 8) * 100,
            (diffR2 & 0x00ff) * 100,
            (diffR2 >> 8) * 100,
            (diffR3 & 0x00ff) * 100,
            (diffR3 >> 8) * 100,
            0,
            0
          ];
        } else {
          const diffR1             = parseInt(Math.abs(Math.round(this.calcR2() * 1000)));
          writerSetting.diyVoltage = [
            (diffR1 & 0x00ff) * 100,
            (diffR1 >> 8) * 100,
            this.modelList[0].pushPower * 100,
            0,
            0,
            0
          ];
        }

        writerSetting.touchSensitivity = 0x40;
        try {
          await bluetoothRepository.writeToWriterWithAllFunc(
              writerSetting,
              false,
              0
          );

          this.$toast({
            type    : "success",
            message : `Write success`,
            duration: 1000
          });
        } catch (e) {
          this.$toast({
            type    : "fail",
            message : `Write fail`,
            duration: 1000
          });
        }
      }

      // //上传到服务器
      // let hw = "";
      // let fw = "";
      // let deviceVersion = this.deviceVersion.split("&");
      // //解析设备的版本信息
      // if (deviceVersion.length === 2) {
      //   hw = parseInt(deviceVersion[0].replace("HW", ""), 16);
      //   fw = parseInt(deviceVersion[1].replace("FW", ""));
      // }
      // const resp = writer.uploadConfig(
      //   this.modelList[this.curveModel].id,
      //   this.modelList[this.curveModel].modeName,
      //   this.cartridgeFlag,
      //   this.macAddress,
      //   this.deviceVersion,
      //   navigator.bluetooth2 ? "Android-wv&1.0.0" : "iOS-wv&1.0.0",
      //   writerSetting
      // );
    },

    calcR2(r1, r2) {
      let t = 880;
      switch (this.modelList[0].materialType) {
        case 1:
          t = 880;
          break;
        case 2:
          t = 734;
          break;
      }
      const TCR = t * Math.pow(10, -6);
      const T1  = 25;
      const R1  = this.r1;
      const T2  = this.modelList[0].temperature;
      const R2  = TCR * (R1 * (T2 - T1)) + R1;

      return R2 - R1;
    },

    calcR2Double(r1, r2) {
      let t = 880;
      switch (this.modelList[0].materialType2) {
        case 1:
          t = 880;
          break;
        case 2:
          t = 734;
          break;
      }
      const TCR = t * Math.pow(10, -6);
      const T1  = 25;
      const R1  = this.doubleR1;
      const T2  = this.modelList[0].temperature2;
      const R2  = TCR * (R1 * (T2 - T1)) + R1;

      return R2 - R1;
    },
    calcR3Double(r1, r2) {
      let t = 880;
      switch (this.modelList[0].materialType2) {
        case 1:
          t = 880;
          break;
        case 2:
          t = 734;
          break;
      }
      const TCR = t * Math.pow(10, -6);
      const T1  = 25;
      const R1  = this.rightR1;
      const T2  = this.modelList[0].temperature3;
      const R2  = TCR * (R1 * (T2 - T1)) + R1;

      return R2 - R1;
    },
    onClickDisconnectCancel() {
      this.showDisconnectPopup = false;
    },
    onClickDisconnectSure() {
      bluetoothRepository.disconnect();
      this.showDisconnectPopup = false;
    },
    onClickSaveCancel() {
      this.showSavePopup = false;
    },
    onClickSaveSure() {
      this.showSavePopup        = false;
      const divSetting          = Object.assign({}, this.modelList[0])
      divSetting.outputDuration = this.outputDurationValue
      divSetting.position       = this.currentDeviceLevel + 1
      setTimeout(() => {
        this.$router.replace({
          name  : "CreateVoltage",
          params: {
            beForm: "Home",
            divSetting
          }
        });
      }, 200);
    },
    onClickHistory() {
      this.$router.push("History");
    },
    onClickLogout(value) {
      if (value) {
        this.showMenuPopup   = false;
        this.showLogoutPopup = false;
        this.$store.dispatch("logout");
        bluetoothRepository.disconnect();
        setTimeout(() => {
          this.$router.replace("Login");
        }, 100);
      } else {
        this.showLogoutPopup = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-popup {
  overflow-y: hidden !important;
}

.container {
  height: 100%;
  background: #6649c4;
  position: relative;
  overflow: hidden;

  .header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;

    .header-menu {
      position: absolute;
      left: 16px;
      width: 25px;
      height: 25px;
    }

    .header-logo {
      width: 86px;
      height: 30px;
    }

    .header-title {
      font-size: 22px;
      font-weight: 400;
      color: #ffffff;
    }

    .header-bluetooth {
      position: absolute;
      right: 16px;
      width: 26px;
      height: 26px;
    }
  }

  .content {
    height: 100%;
    margin-top: 25px;

    .temperature {
      font-size: 14px;
      margin: 10px;
      background: white;
      border-radius: 12px;
      display: flex;
      flex-direction: column;

      .temperature-container {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
      }
    }

    /deep/ .van-slider--disabled {
      .van-slider__bar {
        background: #d6cdf2 !important;
      }
    }

    .model-setting {
      display: flex;
      align-items: center;
      margin: 0 15px;

      .model-select {
        display: flex;
        width: 88%;
        overflow-x: auto;

        .model-item {
          margin-right: 8px;
          padding: 0 4px;
          height: 75px;
          border-radius: 10px;
          border: 1px solid #8866f5;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
        }

        .model-button {
          margin-top: 10px;
          width: 50px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          background: #8866f5;
          border-radius: 20px;
          border: 1px solid #8866f5;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }

        .model-item-active {
          background: #8866f5;
          border: 1px solid #8866f5;
        }

        .model-button-active {
          background: #8866f5;
          border: 1px solid #f1edff;
          color: #f1edff;
        }

        .model-mask {
          position: absolute;
          right: 50px;
          width: 30px;
          height: 77px;
          background: linear-gradient(90deg,
          rgba(102, 73, 196, 0) 0%,
          #6649c4 38%,
          #6649c4 100%);
        }
      }

      .setting {
        width: 26px;
        height: 26px;
        margin-left: 30px;
      }
    }

    .content-main {
      height: calc(100vh - 180px); //168
      margin-top: 20px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      padding: 15px 15px 0 15px;
      overflow-y: auto;
      overflow-x: hidden;

      .main-header {
        display: flex;
        align-items: center;

        span {
          font-size: 18px;
          font-weight: bold;
          color: #555555;
        }

        /deep/ .van-button--disabled {
          border: 1px solid #bbbbbb !important;

          .van-button__text {
            color: #bbbbbb !important;
          }
        }

        .main-header-save {
          width: 60px;
          height: 30px;
          margin-left: auto;
          border-radius: 8px;
          border: 1px solid #6649c4;

          /deep/ .van-button__text {
            font-size: 16px;
            font-weight: 400;
            color: #6649c4;
          }
        }
      }

      .voltage-one {
        margin: 20px 0 20px 0;
        display: flex;
        width: 100%;

        div {
          margin: 0 auto;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
        }
      }

      .voltage-ctrl {
        display: flex;
        width: 100%;

        div {
          margin: 0 auto;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
        }

        .voltage-number {
          width: 30px;
          height: 30px;
          text-align: center;
        }
      }

      .voltage-two {
        display: flex;
        margin: 16px 0 16px 0;

        .slider-button {
          width: 40px;
          height: 40px;
        }

        /deep/ .van-slider {
          margin: 0 auto;
        }
      }

      .voltage-three {
        display: flex;
        width: 100%;

        div {
          margin: 0 auto;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
        }
      }

      .description {
        margin-top: 16px;
        padding-left: 6px;
        font-size: 14px;
        font-weight: 400;
        color: #939598;
        line-height: 15px;
      }

      .device-level {
        padding: 0px 16px;
        font-size: 14px;
        font-weight: normal;
        color: #939598;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        /deep/ .van-dropdown-menu__bar {
          width: 55px;
          height: 25px;
          border-radius: 5px;
          border: 1px solid #d1d3d4;
          box-shadow: none;

          .van-dropdown-menu__item {
            justify-content: flex-start;
          }

          .van-dropdown-menu__title {
            font-size: 11px;
            color: #939598;
            padding-right: 12px;
          }

          .van-dropdown-menu__title--active {
            color: #939598;
          }

          .van-dropdown-menu__title::after {
            top: 42%;
            color: #d1d3d4;
            border: 4px solid #d1d3d4;
            border-color: transparent transparent #d1d3d4 #d1d3d4;
          }
        }

        /deep/ .van-dropdown-item {
          left: 19%;
          width: 19%;
          height: 30%;
          border-radius: 5px;

          .van-overlay {
            height: auto;
          }

          .van-dropdown-item__content {
            border-radius: 5px;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1607843137254902);
            top: 1px;
            left: 10px;
            right: 5px;
            width: auto;
            max-height: 100px;
          }

          .van-cell {
            height: 25px;
            line-height: 25px;
            padding: 0 0 0 6px;
          }

          .van-cell::after {
            display: none;
          }

          .van-cell__title {
            padding-left: 3px;
            font-size: 11px;
            color: #939598;
            white-space: nowrap;
          }

          .van-dropdown-item__option--active {
            background: var(--dropDownActiveColor);
            border-radius: 5px;

            .van-cell__title {
              color: #ffffff !important;
            }
          }

          .van-dropdown-item__icon {
            color: #6649c4;
          }

          .van-dropdown-item__icon::before {
            display: none;
          }
        }
      }

      .double-cartridge {
        display: flex;
        font-size: 12px;
        margin-top: 10px;
      }


      .triple-cartridge {
        display: flex;
        font-size: 12px;
        margin-top: 10px;
      }

      .control {
        display: flex;
        margin-bottom: 94px;
        margin-top: 10px;

        .control-left {
          flex: 1;
          height: 250px;
          background: #f1edff;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          margin-right: 15px;
          padding: 0 15px;

          .title {
            color: #6649c4;
            margin-top: 10px;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;

            .preheat-switch {
              margin-left: auto;
            }
          }

          .subtitle {
            font-size: 14px;
            font-weight: 400;
            margin: 10px 0 0 0;
          }

          .times-item {
            margin: 20px 0 0 0;
            display: flex;
            flex-direction: column;

            .slider-button {
              width: 40px;
              height: 40px;
              margin-top: 10px;
            }

            .times-item-msg {
              margin-top: 16px;
              padding-right: 5px;
              display: flex;
              font-size: 13px;
              font-weight: 400;
              color: #999999;

              .times-left {
                margin-right: auto;
              }

              .times-right {
                margin-left: auto;
              }
            }
          }

          .voltage-item {
            margin: 20px 0 0 0;
            display: flex;
            flex-direction: column;

            .slider-button {
              width: 40px;
              height: 40px;
              margin-top: 10px;
            }

            .voltage-item-msg {
              margin-top: 16px;
              padding-right: 5px;
              display: flex;
              font-size: 13px;
              font-weight: 400;
              color: #999999;

              .voltage-left {
                margin-right: auto;
              }

              .voltage-right {
                margin-left: auto;
              }
            }
          }
        }

        .control-right {
          flex: 1;
          background: #f1edff;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          padding: 10px 15px;

          .title {
            font-size: 16px;
            font-weight: bold;
            white-space: nowrap;
          }

          .nfc-switch {
            margin-top: 10px;
          }

          .msg {
            margin-top: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #ddd;
            line-height: 18px;
          }
        }

        .output-setting {
          flex: 1;
          height: 150px;
          background: #f1edff;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          padding: 0 15px;
          font-size: 14px;

          /deep/ .van-radio {
            min-height: 30px;
            font-size: 16px;
            font-weight: bold;
          }

          .title {
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: bold;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url("../assets/bg/bg_footer.png");
    height: 60px;
    width: 100%;

    .footer-item {
      display: flex;
      width: 100%;
      height: 100%;
      position: relative;
      align-items: center;
      justify-content: center;

      .footer-setting {
        width: 40px;
        height: 40px;
        left: 58px;
        top: 10px;
        position: absolute;
      }

      .footer-upload {
        width: 78px;
        height: 78px;
        margin-bottom: 16px;
      }

      .footer-history {
        width: 40px;
        height: 40px;
        right: 58px;
        top: 10px;
        position: absolute;
      }
    }
  }

  .menu-popup {
    background: transparent;

    .menu-header {
      height: 27%;
      background: #6649c4;
      display: flex;
      flex-direction: column;
      align-items: center;

      .menu-return {
        margin-top: 30px;
        margin-left: 10px;
        margin-right: auto;
      }

      img {
        width: 80%;
        margin-top: 30px;
      }
    }

    .menu-content {
      height: 73%;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      padding: 0 15px;

      .menu-item:first-child {
        margin-top: 30px;
      }

      .menu-item {
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }

      .menu-footer {
        margin-top: auto;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #999999;

        .menu-footer-left {
          margin-right: auto;
        }

        .menu-footer-right {
          margin-left: auto;
          display: flex;
          align-items: center;

          img {
            width: 22px;
            height: 22px;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .bluetooth-popup {
    max-height: 390px;

    .bluetooth-header {
      font-size: 18px;
      font-weight: bold;
      color: #555555;
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      text-align: center;
    }

    .bluetooth-content {
      padding: 20px 16px 15px 16px;
      font-size: 18px;
      font-weight: 400;
      color: #555555;
      display: flex;
      flex-direction: column;
      align-items: center;

      .bluetooth-list {
        display: flex;
        flex-direction: column;
        max-height: 260px;
        overflow-y: auto;
        width: 100%;

        .bluetooth-item {
          height: 50px;
          min-height: 50px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #eeeeee;
          margin-top: 10px;
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #555555;

          img {
            margin-left: 10px;
            width: 26px;
            height: 26px;
          }

          .bluetooth-connect-button {
            height: 40px;
            border-radius: 8px;
            margin-left: auto;
            margin-right: 10px;
            background: #f1edff;
            font-size: 14px;
            font-weight: 400;
            color: #6649c4;
          }
        }
      }
    }
  }

  .save-popup {
    .save-header {
      font-size: 18px;
      font-weight: bold;
      color: #555555;
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      text-align: center;
    }

    .save-content {
      padding: 20px 23px 15px 23px;
      font-size: 18px;
      font-weight: 400;
      color: #555555;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .save-footer {
      display: flex;
      align-items: center;
      width: 100%;

      .save-footer-cancel {
        margin-right: 5px;
        margin-top: 30px;
        background: #f1edff;
        width: 100%;
      }

      .save-footer-sure {
        margin-left: 5px;
        color: #ffffff;
        background: #6649c4;
        margin-top: 30px;
        width: 100%;
      }
    }
  }
}

/deep/ .van-dropdown-item__option {
  img {
    width: 22px;
    height: 22px;
  }
}

.drop-item-level {
  width: 20px;
  height: 20px;
  border: 1px #999 solid;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.drop-item-level__wrap {
  width: 100%;
  padding: 5px 0;
}

.drop-item-level__content {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: 1px #999 solid;
  border-radius: 50%;
}

.flex-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
